/**
 * Created by Jerker Nord on 2018-12-20.
 */

require("@nolimitcity/slot-game/lib/gsap/src/umd/CustomEase.js");
import {NudgeSpinReelPartAnimator} from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelPartAnimator";
import {ThorReelBackgroundController} from "../reelbackground/ThorReelBackgroundController";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ThorGameConfig} from "../../ThorGameConfig";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Ease, Timeline} from "gsap";

export class ThorNudgeReelPartAnimator extends NudgeSpinReelPartAnimator {

    private _reelBackgroundController:ThorReelBackgroundController;

    constructor(reelId:number) {
        super(reelId);
    }

    public getStartSpinAnimate(delay:number, newSymbol:StateReelSymbol):Timeline {
        const timeline:Timeline = super.getStartSpinAnimate(delay, newSymbol);
        timeline.add(() => {
            this._reelBackgroundController.startSpinSpeed = this.calculateStartSpinSpeed();
            this._reelBackgroundController.animate(ReelAnimationState.START_SPIN);
        }, delay);

        return timeline;
    }

    public getSpinAnimation(newSymbol:StateReelSymbol):Timeline {
        const timeline:Timeline = super.getSpinAnimation(newSymbol);
        timeline.add(() => {
            this._reelBackgroundController.spinSpinSpeed = this.calculateSpinSpeed();
            this._reelBackgroundController.animate(ReelAnimationState.SPIN);
        }, 0);
        return timeline
    }

    public getStopSpinAnimation(newSymbol:StateReelSymbol):Timeline {
        const timeline:Timeline = super.getStopSpinAnimation(newSymbol);
        timeline.add(() => {
            this._reelBackgroundController.spinStopSpeed = this.calculationStopSpinSpeed();
            this._reelBackgroundController.animate(ReelAnimationState.STOP_SPIN);
        }, 0);
        return timeline;
    }

    set reelBackgroundController(value:ThorReelBackgroundController) {
        this._reelBackgroundController = value;
    }

    public getNudgeUpAnimation(nextNudgeUpSymbol:StateReelSymbol):Timeline {
        const timeline:Timeline = super.getNudgeUpAnimation(nextNudgeUpSymbol);
        timeline.add(() => this._reelBackgroundController.nudge(this.nudgeStepSpeed, this.ease, this.symStep, this.nudgeSteps), 0);
        return timeline;
    }

    public getNudgeDownAnimation(nextNudgeDownSymbol:StateReelSymbol):Timeline {
        const timeline:Timeline = super.getNudgeDownAnimation(nextNudgeDownSymbol);
        timeline.add(() => this._reelBackgroundController.nudge(this.nudgeStepSpeed, this.ease, this.symStep, this.nudgeSteps), 0);
        return timeline;
    }

    protected fadeOutSymbolBlur():void {
        for(let i:number = 0; i < this._symbolsToAnimate.length; i++) {
            let state:ISymbolStateConfig;
            if(this._symbolsToAnimate[i].currentState == ThorGameConfig.instance.SYMBOL_STATES.spinGlow) {
                state = ThorGameConfig.instance.SYMBOL_STATES.lit;
            } else {
                state = GameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE ? GameConfig.instance.REEL_SPIN_STOP_SYMBOL_STATE() : GameConfig.instance.SYMBOL_STATES.normal
            }
            this._symbolsToAnimate[i].changeState({
                state : state,
                replay : false,
                fadeInDuration : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DURATION,
                fadeInDelay : GameConfig.instance.REEL_SPIN_STOP_SYMBOL_CHANGE_FROM_SPIN_STATE_DELAY
            });
        }
    }

    protected getSpinStopEase():any {
        return CustomEase.create("custom", "M0,0,C0.058,0.259,0.104,0.494,0.212,0.654,0.33,0.83,0.172,0.959,0.312,1,0.352,1.01,0.377,1.008,0.456,0.99,0.515,0.975,0.624,0.982,0.668,0.982,0.706,0.982,0.67,0.998,0.684,1,0.706,1.002,0.943,1,1,1");
    }

    protected getSpinQuickStopEase():any {
        return CustomEase.create("custom", "M0,0,C0.058,0.259,0.104,0.494,0.212,0.654,0.33,0.83,0.172,0.959,0.312,1,0.352,1.01,0.377,1.008,0.456,0.99,0.515,0.975,0.624,0.982,0.668,0.982,0.706,0.982,0.67,0.998,0.684,1,0.706,1.002,0.943,1,1,1");
    }
}